
const theme = {
    global: {
        container: 'xl',
    },
    width: {
        maxwidth: '1470px',
    },
    palette: {  
        header : {
            main: '#FFF',
            contrastText: '#222'
        },
        footer: {
            main: '#efefef',
            contrastText: '#222'
        },
        background: {
            main: '#FFF',
            contrastText: '#222'
        },
        primary: {
            main: '#005EAA',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#E9531C',
            contrastText: '#FFFFFF'
        },
        grey: {
            main: '#7e7c7c',
            contrastText: '#222'
        },

    },
    typography: {
        mainColor: '#222',
        fontFamily: [
            'Metropolis',
        ].join(','),
        h1: {
            fontSize: '2rem',
            '@media (max-width:600px)': {
                fontSize: '2rem',
            }
        },
        h2: {
            fontSize: '1.8rem',
            '@media (max-width:600px)': {
                fontSize: '1.8rem',
            }
        },
        h3: {
            fontSize: '1.2rem',
            fontWeight: 'bold'
        },
        h4: {
            fontSize: '1rem',
            textTransform: 'none',
        },
        p: {
            fontSize: '1rem',
            lineHeight: '1.6em', 
        },
    },
    components: {
        // Name of the component
        MuiBackdrop: {
            styleOverrides: {
                // Name of the slot
                root: {
                    backdropFilter: 'blur(5px)',
                }
            },
        },
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    borderRadius: 5,
                    textTransform: 'none',
                    fontWeight: 'bold',
                    padding: '1em 2em'
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 641,
            md: 852,
            lg: 957,
            xl: 1536,
        },
    }

}

export default theme
